module.exports = __webpack_public_path__ + "img/logo.684bf681.svg";